export default __webpack_public_path__ + "static/media/firewood-storage.a2c0dc66.jpg";